






import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { $t } from "@/lib/i18nHelpers";
import ModalView from "@/components/ModalView";
import SelectUserTagsController from "@/components/SelectUserTagsController";

@Component({ name: "SelectUserTagsModal", components: { ModalView, SelectUserTagsController } })
export default class SelectUserTagsModal extends Vue {
  @Prop({ required: true })
  public value!: boolean;

  @Prop({ type: String, default: $t("Categories") })
  public title!: string;

  @Prop({ type: Boolean, default: false })
  public modal!: boolean;
}
